import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
//import './registerServiceWorker'

import "@/assets/styles/tailwind.postcss"
import "@/assets/styles/styles.scss"

Vue.config.productionTip = false

async function frame() {
    if (store.state.update) {
        store.dispatch("tick")
        requestAnimationFrame(frame)
    }
}

requestAnimationFrame(frame)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")
